import { WallboxTariffResponseDto } from '../api/dto/wallbox.dto'

/**
 * Function for mapping proper static prices per each tariffs.
 * @param tariff - single TariffCoreDto object
 * @returns grid as number and solar as number
 */
export const getStaticPrices = (tariff: WallboxTariffResponseDto): { grid: number; solar: number } => {
  let tempGridPrice = 0
  let tempSolarPrice = 0

  for (const price of tariff.tariff.elements[0].price_components) {
    price.type === 'FLAT' && (tempSolarPrice = price.price)
  }
  for (const price of tariff.tariff.elements[0].price_components) {
    price.type === 'ENERGY' && (tempGridPrice = price.price)
  }

  return {
    grid: tempGridPrice,
    solar: tempSolarPrice,
  }
}
